import { ErrorPageContent } from '../../content.types';

export const phoneNumberInUseError: ErrorPageContent = {
  header: 'That phone number is already in use',
  body:
    'This phone number is already registered with Summer Health. ' +
    'Please log in or contact support if you believe this is a mistake.',
  cta: 'Log in',
  ctaUrl: '/api/auth/login',
};

export const partnershipTokenError: ErrorPageContent = {
  header: 'We had trouble verifying your invite',
  body:
    'Your invite link may have expired or been used%errorMessage%. ' +
    'Please try the link again or reach out to support@summerhealth.com.',
  cta: 'Try again',
  ctaUrl: '/welcome/verify',
};

export const errorPages: Record<string, ErrorPageContent> = {
  '5ed0pnRCgGyINd1LtcbueN': phoneNumberInUseError,
  '5ww7LCpR3Q41BQpMjYdS47': partnershipTokenError,
};
